export const getDevicePlatform = (): "ios" | "android" | "web" => {
    const ua = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(ua)) {
        return "ios";
    }
    if (/android/.test(ua)) {
        return "android";
    }
    return "web";
};

export const getDeviceName = (): string => {
    if ((navigator as any).userAgentData) {
        const uaData = (navigator as any).userAgentData;
        const brands = uaData.brands
            .map((b: any) => `${b.brand} ${b.version}`)
            .join(", ");
        return `${brands} (${uaData.platform})`;
    }

    return navigator.userAgent;
};